module.exports = __webpack_public_path__ + "media/images/sp/lp/bg-main-77ede410cb2227dd8dd93aa95918f03c.png";